/* 涉及权限的路由和按钮挂载到全局，在json.js种统一管理数据
 ** 调用方法：this.$authRoute、this.$nuxt.$authRoute，或者服务端对象app.$authRoute
 */

import { authRoute, authButton } from '../utils/json.js';
export default {
  install: (vue) => {
    vue.prototype.$authRoute = authRoute
    vue.prototype.$authButton = authButton
  }
};
